export default {
  outroLine1: "With best regards,",
  outroLine2: "Your REMARKET NOW Sales-Team",
  formerlyB4BMall: "FORMERLY B4B-MALL",
};
